import { Flash } from '@acast/decibel';
import moment from 'moment';
import T from 'prop-types';
import React from 'react';

const EpisodePublishedAlert = ({ date }) => {
  const publishDate = moment(date);

  return (
    <Flash intent="success">
      Your episode was released on <strong>{publishDate.format('MMMM Do, YYYY @ LT')}</strong>
    </Flash>
  );
};

EpisodePublishedAlert.propTypes = {
  date: T.string.isRequired,
};

export default EpisodePublishedAlert;
